import { unaryRpc } from "@redotech/rpc/definition";
import * as zExt from "@redotech/rpc/ext";
import * as z from "zod";

export const copyLatestFlow = unaryRpc({
  name: "copyLatestFlow",
  input: z.object({
    sourceTeamId: zExt.objectId(),
    destinationTeamId: zExt.objectId(),
    flowType: z.enum(["return", "claim", "warranty"]),
  }),
  output: z.object({
    success: z.boolean(),
    flowId: zExt.objectId().optional(),
    published: z.boolean(),
    message: z.string().optional(),
  }),
});
